import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { CoreResponse } from "./models/core-response";
import { CoreResponseCode } from "./constants/enums";
export function unwrap<T>(toast: ToastrService){
    return (observable: Observable<CoreResponse<T>>) => {
        return new Observable<T>((subscriber) => {
            const subscription = observable.subscribe({
                next(value) {
                    if(value.responseCode !== CoreResponseCode.Success){
                        toast.error(value.message);
                        subscriber.next(null);
                    } else {
                        subscriber.next(value.result);
                    }
                },
                error(err) {
                    toast.error("API error");
                    subscriber.error(err);
                },
                complete(){
                    subscriber.complete();
                }
            });
            return () => {
                subscription.unsubscribe();
            };
        });
    }
}

export function unwrapArray<T>(toast: ToastrService){
    return (observable: Observable<CoreResponse<T>>) => {
        return new Observable<T[]>((subscriber) => {
            const subscription = observable.subscribe({
                next(value) {
                    if(value.responseCode !== CoreResponseCode.Success){
                        toast.error(value.message);
                        subscriber.next(null);
                    } else {
                        subscriber.next(value.results);
                    }
                },
                error(err) {
                    toast.error("API error");
                    subscriber.error(err);
                },
                complete(){
                    subscriber.complete();
                }
            });
            return () => {
                subscription.unsubscribe();
            };
        });
    }
}